:host{background:#fdfdfd}
/*# sourceMappingURL=main-video-toolbar.component.css.map */
